import { useQuery } from "@tanstack/react-query";
import { bullhornService } from "@/services/bullhornService";

export const bullhornQueryKeys = {
  all: ["bullhorn"],
  hotlist: () => [...bullhornQueryKeys.all, "hotlist"],
};

export const useBullhornHotlist = (options = {}) => {
  return useQuery({
    queryKey: bullhornQueryKeys.hotlist(),
    queryFn: () => bullhornService.getHotlist(),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
